import { EnumCatalogueEntryResponseDto } from 'src/app/shared/data/dto/enum-catalogue/enum-catalogue-entry-response-dto.model';

import { ENUM_REGISTRY, enumMembers } from './enum-registry';

const DRIFT_PREFIX = 'Enum catalogue drift:';

/**
 * Compares each registered TS enum with its catalogue entry by member name and value, and returns one message per
 * enum missing from the catalogue and per member that is missing on either side or has another value.
 */
export function findEnumCatalogueDrift(
	entries: readonly EnumCatalogueEntryResponseDto[],
	registry: Readonly<Record<string, object>> = ENUM_REGISTRY
): string[] {
	const catalogue = new Map(entries.map((entry) => [entry.name, entry]));
	const problems: string[] = [];

	for (const [name, enumObject] of Object.entries(registry)) {
		const entry = catalogue.get(name);
		if (entry === undefined) {
			problems.push(`${DRIFT_PREFIX} ${name} is not in the backend catalogue`);
			continue;
		}

		const frontend = enumMembers(enumObject);
		const backend = new Map(entry.values.map((value) => [value.code, value.value]));

		for (const [code, value] of Object.entries(frontend)) {
			const backendValue = backend.get(code);
			if (backendValue === undefined) {
				problems.push(`${DRIFT_PREFIX} ${name}.${code} = ${value} is not in the backend catalogue`);
			} else if (backendValue !== value) {
				problems.push(`${DRIFT_PREFIX} ${name}.${code} is ${value} in TS but ${backendValue} in the backend catalogue`);
			}
		}
		for (const [code, value] of backend) {
			if (!Object.hasOwn(frontend, code)) {
				problems.push(`${DRIFT_PREFIX} ${name}.${code} = ${value} is missing from the TS enum`);
			}
		}
	}

	return problems;
}
